module.exports = __webpack_public_path__ + "img/positionmehover.a183fcda.png";